import { useAuth0 } from "@auth0/auth0-react";
import { Outlet } from "react-router-dom";

import { LoggedOut } from "./LoggedOut";

export const AuthGuard: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) return null;
  if (!isAuthenticated) return <LoggedOut />;

  return <Outlet />;
};
